import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { TaskService } from 'src/app/services/task.service';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { Enums } from 'src/app/helpers/enums';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { UserTeamMasterService } from 'src/app/services/user-team-master.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
@Component({
  selector: 'app-update-activated-task',
  templateUrl: './update-activated-task.component.html',
  styleUrls: ['./update-activated-task.component.css']
})
export class UpdateActivatedTaskComponent implements OnInit {

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  selectedFileName: any;

  public downloadLink: string;
  activatedTaskForm: FormGroup;
  uploadProofactivatedTaskForm: FormGroup;
  meetingTypes: any[];
  groupTypes: any[];
  taskId: string;
  meetingtypeId: string;
  meetingType: string;
  groupId: string;
  groupName: string;
  policyTypes: any[];
  taskStatusTypes: any[];
  riskTypes: any[];
  dateOptions: any[];
  departments: any[];
  users: any[];

  assignedusers: any[];
  escalation2Users: any[];
  escalation1Users: any[];
  escalation1ofResponsibleUsers: any[];
  escalation2ofResponsibleUsers: any[];
  responsibleUsers: any[];

  collegues: any[];
  taskTriggerTypes: any[];
  policytypeId: string;
  risktypeId: string;
  TriggerStartingDateModel: any;
  EndDateModel: any;
  IsTriggerDateGreaterEndDate: boolean = false;
  CompletedDateModel: any;
  CompletionDateModel: any;
  triggerType: string;
  tasktriggerId: string;
  IsSelectedUpload: any;
  fileUpload: any;
  // filesToUpload: Array<File>;
  orignalName: any;
  fileName: any;
  originalfileName: string;
  fileuploadstatus: any;
  TaskStatusModel: any;
  documentId: string;
  minimumDate: any;
  triggerID: string;
  checkValidationInput: any;
  error: any = { isError: false, errorMessage: '' };
  reminderFrequencyError: any = { isError: false, errorMessage: '' };
  firstEscalationStartError: any = { isError: false, errorMessage: '' };
  secondEscalationStartError: any = { isError: false, errorMessage: '' };
  firstEscalationreminderFrequencyError: any = { isError: false, errorMessage: '' };
  secondEscalationreminderFrequencyError: any = { isError: false, errorMessage: '' };
  hasPermission: any;
  assignedMeetingID: any;
  todaysDate: any;
  token: any = localStorage.getItem('token')
  disabledOnclick: boolean = false;
  isUploading: boolean = false;
  isPageLoading: boolean = false;
  activatedProcessId: any;
  isExtensionTrue: boolean = true;
  fixedDateDateModel: any;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  typeHasError: boolean = true;
  FileOrignalName: any;
  changedName: any;
  titleOnAddUpdate: any;
  pdfArray1 = [];
  taskProofData = [];
  documentIdToDelete = '';
  pdfToDelete = '';
  tempAssignedusers: any[];
  tempCollegues: any[];
  tempEscalation1Users: any[];
  tempEscalation2Users: any[];
  selectedUsers: any = [];
  userTeamData: any = [];
  imageAdd: boolean=false;
  imageAddRev: boolean=false;
  imageEdit: boolean = true;
  escalationBlockCollapsed: boolean = true;
  downloadURLForUPSI: any;
  listOfFiles: any[] = [];
  fileList: File[] = [];
  fileNameArray: any[] = [];
  combineArray: any[] = [];
  filesToUpload: any;
  date = new Date();
  timestamp: any;

  constructor(private taskService: TaskService,
    private route: ActivatedRoute,
    private groupMasterService: GroupMasterService,
    private documentManagementMasterService: DocumentManagementMasterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private customValidation: CustomValidation,
    private documentManagementService: DocumentManagementMasterService,
    private meetingService: MeetingMasterService,
    private authAlert: AuthAlertComponent,
    private userteammasterService: UserTeamMasterService,
  ) {

    this.dateOptions = Enums.DateOptions;
    this.policyTypes = this.commonFunction.sortByKey(Enums.policyType, 'name');
    this.riskTypes = this.commonFunction.sortByKey(Enums.RiskTypes, 'name');
    this.departments = this.commonFunction.sortByKey(Enums.Departments, 'name');
    this.taskStatusTypes = this.commonFunction.sortByKey(Enums.TaskStatus, 'name');
    this.taskStatusTypes.forEach(element => {
      if (element.name == 'Delayed Completion') {
        element.isDisabled = true;
      } else {
        element.isDisabled = false;
      }
    })
    // var taskstatusTypes = this.commonFunction.sortByKey(Enums.TaskStatus, 'name');
    // this.taskStatusTypes = $(taskstatusTypes).filter(function (i, n) { return (n.id !="3")  });

    this.getUsersMaster();
    this.downloadURLForUPSI = environment.pssServerUrl + 'predefinedTask/download/';
  }

  getUsersMaster() {
    this.userteammasterService
      .getUserTeamMasterData()
      .subscribe((userMasterData) => {
        this.userTeamData = userMasterData.userDataList;
      });
  }

  getMeetingTypeList() {
    this.meetingTypes = [];
    this.taskService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          this.meetingTypes = meetingTypeList.meetingTypeList;
        }
      })
  }
  addNewDoc(){
    this.imageAdd = true;
    this.imageEdit = false;
    this.imageAddRev = true;
  }
  revert() {
    this.imageAdd = false;
    this.imageAddRev = false;
    this.imageEdit = true;
  }
  onFileChange(event) {
    let reader = new FileReader();
    this.IsSelectedUpload = true;
    if (event.target.files && event.target.files.length > 0) {
      var checkfile = this.commonFunction.checkFileExtension(event);
      if (checkfile) {
        this.filesToUpload = <Array<File>>event.target.files;
        this.isExtensionTrue = true;

        this.IsSelectedUpload = true;
        let file = event.target.files[0];
        this.originalfileName = file.name;
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        const headers = new Headers();
        headers.append('Content-Type', 'multipart/form-data');
        this.fileUpload = formData
        reader.readAsDataURL(file);
        reader.onload = () => {
        };
      } else {
        this.isExtensionTrue = false;
      }
    }
  }
  onFileChanged(event: any) {
    this.timestamp = Date.now();
    console.log('event', event.target.files)
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      this.filesToUpload = event.target.files[i];
      let fileObj = {
        target: {
          files: [this.filesToUpload]
        }
      }
      if(this.commonFunction.checkFileExtension(fileObj)){

        var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj,fileObj)
        if(filenameValidation == "Valid"){
          this.fileList.push(this.filesToUpload);
          this.listOfFiles.push(this.filesToUpload.name);
        } else {
          this.alert.error(filenameValidation);
        }
      } else {
        this.alert.error("Invalid file extension")
      }
    }   
} 
  upload() {
    var file = this.filesToUpload;
    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      this.fileuploadstatus = result;
    });
  }


  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        //this.agendaAddForm.controls.uploadFile.setValue(formData);
        this.orignalName = newDate + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }


  uploadProofDocument() {
    this.disabledOnclick = true;
    this.fileName = this.uploadProofactivatedTaskForm.controls.fileData.value;
    if (this.filesToUpload == undefined) {
      this.IsSelectedUpload = true;
      return false;
    }
    // this.upload();
    if (this.documentId == "" || this.documentId == null || this.documentId === undefined) {
      var file = this.filesToUpload;
      this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
        this.fileuploadstatus = result;
        var newDocumentManagement = {
          "DocumentManagement":
          {
            DocumentName: this.activatedTaskForm.controls.TaskName.value,
            DateOfDocument: new Date(),
            Upload: this.orignalName,
            OriginalFileName: this.originalfileName,
            CompletedDate: "",
            MeetingTypeID: null,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            DirectorKmp: "None",
            DirectorID: null,
            KMPID: null,
            Remarks: "",
            Overwrite: false,
          }
        }
        this.documentManagementService.addDocumentManagement(newDocumentManagement)
          .subscribe((documentManagement: any) => {
            this.disabledOnclick = false;
            if (documentManagement.status == 0) {
              this.updateDocumentProofID(documentManagement.result._id);
              $("btnsaveTask").prop("disabled", false);
            }
            else {
              $('#uploadProofDialog').modal('toggle');
              $("btnsaveTask").prop("disabled", false);
              this.alert.error(documentManagement.message);
            }

          });
      }, (error) => {
        this.alert.error(error);
        // this.disabledOnclick = false;
        return false;

      });

    }
    else {

      var updatedDocumentManagement = {
        _id: this.documentId,
        DocumentName: this.activatedTaskForm.controls.TaskName.value,
        DateOfDocument: new Date(),
        Upload: this.orignalName,
        OriginalFileName: this.originalfileName,
        CompletedDate: "",
        MeetingTypeID: null,
        ParentDocumentTypeID: null,
        ParentSubDocumentTypeID: null,
        DirectorKmp: "None",
        DirectorID: null,
        KMPID: null,
        Remarks: "",
        Overwrite: false,
      }

      this.documentManagementService.updateDocumentManagement(updatedDocumentManagement)
        .subscribe((documentManagement: any) => {
          if (documentManagement.status == 0) {
            $('#uploadProofDialog').modal('toggle');
            $("btnsaveTask").prop("disabled", false);
            this.alert.success("Document uploaded successfully");
          }
          else {
            $('#uploadProofDialog').modal('toggle');
            $("btnsaveTask").prop("disabled", false);
            this.alert.error("Error occured on uploading file");
          }

        })

    }
  }



  updateDocumentProofID(documentId) {
    var uploadedProof = {
      activatedTaskId: this.taskId,
      documentId: documentId
    }
    this.taskService.updateDocumentIdforActivatedTask(uploadedProof)
      .subscribe(updatedActivatedTask => {
        if (updatedActivatedTask.status == 0) {
          $('#uploadProofDialog').modal('toggle');
          this.alert.success("Document uploaded successfully");
          this.ngOnInit();
        }
        else {
          this.alert.error(updatedActivatedTask.message);
        }
      });
  }



 setDate(date: any): string | null {
  return this.commonFunction.setDate(date);
 }


  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
      //.toLocaleDateString();
    }
    return null;
  }

  showSelectedTriggerID(triggertype, tasktriggerid) {

    // if (this.activatedTaskForm.controls.TriggerType.value != triggertype) {
    if (triggertype == 'Periodic') {
      this.activatedTaskForm.controls.tasktriggerId.setValue(tasktriggerid);
      this.activatedTaskForm.controls.tasktriggerId.disable();
    }
    else {
      this.activatedTaskForm.controls.tasktriggerId.enable();
      this.activatedTaskForm.controls.tasktriggerId.setValue(tasktriggerid);
    }
  }

  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          this.groupTypes = groupList.groupList;
        }
      })
  }

  getTaskTriggerTypeList() {
    this.taskTriggerTypes = [];
    this.taskService.getTaskTriggersList()
      .subscribe(tasktriggerList => {
        if (tasktriggerList.status == 0) {
          this.taskTriggerTypes = tasktriggerList.tasktriggerList;
        }
      })
  }

  ShowActivatedTasks() {

    var redirectfromActivatedProcessId = localStorage.getItem('redirectfromActivatedProcess');
    localStorage.removeItem('redirectfromActivatedProcess');
    this.activatedProcessId = redirectfromActivatedProcessId;

    var fromMeeting = localStorage.getItem('fromMeeting');
    localStorage.removeItem('fromMeeting');
    if (fromMeeting != undefined || fromMeeting != null) {

      this.router.navigate(
        [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', fromMeeting, 'Compliance'] } }],
        { relativeTo: this.activatedRoute.parent });
      // this.router.navigate(['/meeting/edit/' + fromMeeting + '/Compliance']);
    }
    else if (redirectfromActivatedProcessId != undefined || redirectfromActivatedProcessId != null) {

      this.router.navigate(
        [{ outlets: { 'structure-outlet': ['process', 'activatedtasks', this.activatedProcessId] } }],
        { relativeTo: this.activatedRoute.parent });
      // this.router.navigate(['/process/activatedtasks/' + this.activatedProcessId]);
    }
    else {

      this.router.navigate(
        [{ outlets: { 'structure-outlet': ['tasks', 'activated'] } }],
        { relativeTo: this.activatedRoute.parent });
      // this.router.navigate(['/tasks/activated']);
    }

  }

  TaskStatusChange(event) {
    var taskStatus = event.target.value;

    if (taskStatus === '2') {
      this.activatedTaskForm.controls.CompletedDate.setValidators([Validators.required]);
      this.activatedTaskForm.controls.CompletedDate.updateValueAndValidity();

    } else {
      this.activatedTaskForm.controls.CompletedDate.setValue('');
      this.activatedTaskForm.controls.CompletedDate.clearValidators();
      this.activatedTaskForm.controls.CompletedDate.updateValueAndValidity();

    }


    for (let i in this.taskStatusTypes) {
      this.taskStatusTypes[i].isDisable = false;
    }
    let index = this.taskStatusTypes.findIndex((i => i.id == "3"));
    this.taskStatusTypes[index].isDisable = true;



  }

  updateActivatedTask() {
    this.disabledOnclick = true;
    this.updateReminderDays();
    if (this.activatedTaskForm.invalid) {
      this.disabledOnclick = false;
      this.activatedTaskForm.markAllAsTouched();
      return;
    }
    if (this.activatedTaskForm.status == "VALID") {

      var checkTasktrigger = null;
      if (this.activatedTaskForm.controls.TriggerType.value == 'Event') {
        checkTasktrigger = 1
      }
      if (this.activatedTaskForm.controls.TriggerType.value == 'Periodic') {
        checkTasktrigger = 2
      }

      if(this.triggerType === "Event"){
        this.activatedTaskForm.controls.endDate.setValue(null)
      }
      var date = new Date();
      var timestamp = date.getTime();
      var activatedTask = {
        activatedTaskId: this.taskId,
        TaskName: this.activatedTaskForm.controls.TaskName.value.trim(),
        TaskDescription: this.activatedTaskForm.controls.TaskDescription.value.trim(),
        GroupID: this.activatedTaskForm.controls.groupId.value,
        EmailSendForTask: this.activatedTaskForm.controls.Email.value,

        //MeetingTypeID: this.activatedTaskForm.controls.meetingtypeId.value,
        MeetingTypeID: (this.activatedTaskForm.controls.meetingtypeId.value == "") ? null : this.activatedTaskForm.controls.meetingtypeId.value,
        ReminderDays: this.activatedTaskForm.controls.ReminderDays.value,
        ReminderDate: this.setDate(this.activatedTaskForm.controls.ReminderDate.value),
        ReminderPeriod: this.activatedTaskForm.controls.ReminderFrequency.value,
        EscalationDays: this.activatedTaskForm.controls.EscalationDays.value,
        Level2EscalationDays: this.activatedTaskForm.controls.Level2EscalationDays.value,
        CompletionDays: this.activatedTaskForm.controls.CompletionDays.value,
        TriggerType: checkTasktrigger,
        TriggerID: this.activatedTaskForm.controls.tasktriggerId.value,
        DateOption: this.activatedTaskForm.controls.DateOption.value,
        DepartmentGroupID: this.activatedTaskForm.controls.Department.value,

        ReminderPeriodLevel1: this.activatedTaskForm.controls.ReminderFrequencyLevel1.value,
        ReminderPeriodLevel2: this.activatedTaskForm.controls.ReminderFrequencyLevel2.value,

        EmailContents: this.activatedTaskForm.controls.EmailContents.value,
        //Remarks: this.taskForm.controls.Remarks.value,
        PolicyType: this.activatedTaskForm.controls.policytypeId.value,
        RiskType: this.activatedTaskForm.controls.risktypeId.value,
        PreConsequences: this.activatedTaskForm.controls.PreConsequences.value,
        UserConsequences: this.activatedTaskForm.controls.UserConsequences.value,
        AssignedTo: (this.activatedTaskForm.controls.AssignedTo.value == "") ? null : this.activatedTaskForm.controls.AssignedTo.value,
        ResponsibleUser: (this.activatedTaskForm.controls.ResponsibleUser.value == "") ? null : this.activatedTaskForm.controls.ResponsibleUser.value,

        Escalation1ofAssignedTo: (this.activatedTaskForm.controls.Escalation1ofAssignedTo.value == "") ? null : this.activatedTaskForm.controls.Escalation1ofAssignedTo.value,
        Escalation2ofAssignedTo: (this.activatedTaskForm.controls.Escalation2ofAssignedTo.value == "") ? null : this.activatedTaskForm.controls.Escalation2ofAssignedTo.value,
        Escalation1ofResponsibleUser: (this.activatedTaskForm.controls.Escalation1ofResponsibleUser.value == "") ? null : this.activatedTaskForm.controls.Escalation1ofResponsibleUser.value,
        Escalation2ofResponsibleUser: (this.activatedTaskForm.controls.Escalation2ofResponsibleUser.value == "") ? null : this.activatedTaskForm.controls.Escalation2ofResponsibleUser.value,

        TriggerStartDate: this.setDate(this.activatedTaskForm.controls.TriggerStartingDate.value),
        EndDate: this.setDate(this.activatedTaskForm.controls.endDate.value),

        TaskRemarks: this.activatedTaskForm.controls.TaskRemarks.value,
        //TaskStatus: this.activatedTaskForm.controls.TaskStatus.value,
        TaskStatus: (this.activatedTaskForm.controls.TaskStatus.value == '0') ? 1 : this.activatedTaskForm.controls.TaskStatus.value,

        CompletedDate: this.setDate(this.activatedTaskForm.controls.CompletedDate.value),
        Collegues: (this.activatedTaskForm.controls.Collegues.value == "") ? null : this.activatedTaskForm.controls.Collegues.value,
        TaskParticulars: this.activatedTaskForm.controls.TaskParticulars.value,
        FixedDate: this.setDate(this.activatedTaskForm.controls.fixedDate.value),
        DocumentFile: [] as any

      }

      this.listOfFiles = this.listOfFiles.map(f =>{return `${timestamp}-${f}`});

      this.combineArray = this.listOfFiles.concat(this.fileNameArray);
      var removeNullElementFromArray = this.combineArray.filter(function (e) {return e != null;});
      activatedTask.DocumentFile.push(removeNullElementFromArray);
      activatedTask.DocumentFile = activatedTask.DocumentFile.join(',')
     
      this.isUploading = true;
      this.taskService.updateActivatedTask(activatedTask)
        .subscribe(task => {
          this.isUploading = false;
          this.disabledOnclick = false;
          if (task.status == 0) {
            //this.router.navigate(['/activatedTaskList']);

            var redirectfromActivatedProcessId = localStorage.getItem('redirectfromActivatedProcess');
            localStorage.removeItem('redirectfromActivatedProcess');
            this.activatedProcessId = redirectfromActivatedProcessId;

            var fromMeeting = localStorage.getItem('fromMeeting');
            localStorage.removeItem('fromMeeting');
            // localStorage.removeItem('fromMeeting');
            this.assignedMeetingID = fromMeeting;
            if (this.assignedMeetingID != undefined || this.assignedMeetingID != null) {
              this.alert.successWithOk1(task.message, () => {
                this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.assignedMeetingID, 'Compliance'] } }],
                  { relativeTo: this.route.parent });
              });
            }
            else if (this.activatedProcessId != undefined || this.activatedProcessId != null) {
              this.alert.successWithOk1(task.message, () => {
                this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['process', 'activatedtasks', this.activatedProcessId] } }],
                  { relativeTo: this.activatedRoute.parent });
              });
            } else {
              this.alert.successWithOk1(task.message, () => {
                this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['tasks', 'activated'] } }],
                  { relativeTo: this.activatedRoute.parent });
              });
            }

          }
          else {
            this.alert.error(task.message);
          }
        }, () => {
          this.isUploading = false;
          this.disabledOnclick = false;
        });

    } else {
      return false;
    }

  }


  getTaskStatus(duedate, completeddate, taskStatus) {
    var taskStatusId = "";
    var dueDate = (duedate != null || duedate != undefined) ? duedate : null;
    var completeddate = (completeddate != null || completeddate != undefined) ? completeddate : null;

    if (dueDate != null && completeddate != null) {
      if (completeddate > dueDate) {

        taskStatusId = Enums.TaskStatus[2].id;

      }
      else {
        taskStatusId = taskStatus;
      }
    }
    else {
      taskStatusId = taskStatus;
    }

    return taskStatusId;
  }



  //Load task by id to edit
  GetSelectedTaskDetail(taskId) {
    this.taskService.getActivatedTaskByTaskId(taskId)
      .subscribe((taskData: any) => {
        if (taskData.status == 0) {
          let triggerDate;
          let endDate;
          let completionDate;
          this.documentId = (taskData.taskData[0].DocumentID == null || taskData.taskData[0].DocumentID == undefined) ? '' : taskData.taskData[0].DocumentID;
          //this.taskId = taskData.taskData[0].taskId;
          this.activatedTaskForm.controls.TaskName.setValue(taskData.taskData[0].TaskName);
          this.selectedFileName=taskData.taskData[0].DocumentFile

          if (taskData.taskData[0].EmailSendForTask) {
            this.activatedTaskForm.controls.Email.setValue(true);
          }
          else {
            this.activatedTaskForm.controls.Email.setValue(false);
          }
          this.activatedTaskForm.controls.DocumentFile.setValue((taskData.taskData[0].DocumentFile == null || taskData.taskData[0].DocumentFile == undefined) ? '' : taskData.taskData[0].DocumentFile);
          this.activatedTaskForm.controls.TaskDescription.setValue(taskData.taskData[0].TaskDescription);
          this.activatedTaskForm.controls.meetingtypeId.setValue((taskData.taskData[0].MeetingTypeID == null || taskData.taskData[0].MeetingTypeID == undefined) ? '' : taskData.taskData[0].MeetingTypeID);
          this.activatedTaskForm.controls.ResponsibleUser.setValue((taskData.taskData[0].ResponsibleUser == null || taskData.taskData[0].ResponsibleUser == undefined) ? '' : taskData.taskData[0].ResponsibleUser);
          this.activatedTaskForm.controls.groupId.setValue((taskData.taskData[0].GroupID == null || taskData.taskData[0].GroupID == undefined) ? '' : taskData.taskData[0].GroupID);

          const triggerDateFromApi = this.parseApiDate(taskData.taskData[0].TriggerStartDate || taskData.taskData[0].FixedDate || taskData.taskData[0].DueDate);
          if (triggerDateFromApi) {
            const pickerValue = this.convertDateToPicker(triggerDateFromApi);
            this.activatedTaskForm.controls.TriggerStartingDate.setValue(pickerValue);
            this.TriggerStartingDateModel = pickerValue;
            this.getMinimumDate(triggerDateFromApi);
          } else {
            const today = new Date();
            const pickerValue = this.convertDateToPicker(today);
            this.activatedTaskForm.controls.TriggerStartingDate.setValue(pickerValue);
            this.TriggerStartingDateModel = pickerValue;
            this.getMinimumDate(today);
          }

          const fixedDateFromApi = this.parseApiDate(taskData.taskData[0].FixedDate || taskData.taskData[0].DueDate);
          if (fixedDateFromApi) {
            const pickerValue = this.convertDateToPicker(fixedDateFromApi);
            this.activatedTaskForm.controls.fixedDate.setValue(pickerValue);
            this.fixedDateDateModel = pickerValue;
          } else {
            this.activatedTaskForm.controls.fixedDate.setValue(null);
            this.fixedDateDateModel = null;
          }

          const endDateFromApi = this.parseApiDate(taskData.taskData[0].EndDate);
          if (endDateFromApi) {
            const pickerValue = this.convertDateToPicker(endDateFromApi);
            this.activatedTaskForm.controls.endDate.setValue(pickerValue);
            this.EndDateModel = pickerValue;
          } else {
            this.activatedTaskForm.controls.endDate.setValue(null);
            this.EndDateModel = null;
          }

          const completedDateFromApi = this.parseApiDate(taskData.taskData[0].CompletedDate);
          if (completedDateFromApi) {
            const pickerValue = this.convertDateToPicker(completedDateFromApi);
            this.activatedTaskForm.controls.CompletedDate.setValue(pickerValue);
            this.CompletedDateModel = pickerValue;
          } else {
            this.activatedTaskForm.controls.CompletedDate.setValue(null);
            this.CompletedDateModel = null;
          }
          // this.activatedTaskForm.controls.TriggerStartingDate.setValue(taskData.taskData[0].TriggerStartingDate);
          // this.activatedTaskForm.controls.CompletedDate.setValue(taskData.taskData[0].CompletedDate);
          //this.activatedTaskForm.controls.AssignedTo.setValue(taskData.taskData[0].AssignedTo);
          this.activatedTaskForm.controls.DateOption.setValue((taskData.taskData[0].DateOption == null || taskData.taskData[0].DateOption == undefined) ? '' : taskData.taskData[0].DateOption);
          this.activatedTaskForm.controls.ReminderFrequencyLevel2.setValue(taskData.taskData[0].ReminderFrequencyLevel2);
          this.activatedTaskForm.controls.ReminderFrequency.setValue(taskData.taskData[0].ReminderFrequency);
          this.activatedTaskForm.controls.ReminderFrequencyLevel1.setValue(taskData.taskData[0].ReminderFrequencyLevel1);

          this.activatedTaskForm.controls.policytypeId.setValue((taskData.taskData[0].PolicyType == null || taskData.taskData[0].PolicyType == undefined) ? '' : taskData.taskData[0].PolicyType);
          this.activatedTaskForm.controls.risktypeId.setValue((taskData.taskData[0].RiskType == null || taskData.taskData[0].RiskType == undefined) ? '' : taskData.taskData[0].RiskType);
          this.activatedTaskForm.controls.PreConsequences.setValue((taskData.taskData[0].PreConsequences == null || taskData.taskData[0].PreConsequences == undefined) ? '' : taskData.taskData[0].PreConsequences);
          this.activatedTaskForm.controls.UserConsequences.setValue((taskData.taskData[0].UserConsequences == null || taskData.taskData[0].UserConsequences == undefined) ? '' : taskData.taskData[0].UserConsequences);
          this.activatedTaskForm.controls.tasktriggerId.setValue((taskData.taskData[0].TriggerID == null || taskData.taskData[0].TriggerID == undefined) ? '' : taskData.taskData[0].TriggerID);
          this.activatedTaskForm.controls.EmailContents.setValue((taskData.taskData[0].EmailContents == null || taskData.taskData[0].EmailContents == undefined) ? '' : taskData.taskData[0].EmailContents);
          this.activatedTaskForm.controls.CompletionDays.setValue((taskData.taskData[0].CompletionDays == null || taskData.taskData[0].CompletionDays == undefined) ? '' : taskData.taskData[0].CompletionDays);
          this.triggerID = ((taskData.taskData[0].TriggerID == null || taskData.taskData[0].TriggerID == undefined) ? '' : taskData.taskData[0].TriggerID);


          if (taskData.taskData[0].TriggerType === 1) {
            this.activatedTaskForm.controls.TriggerType.setValue('Event');
            this.CheckTriggerType('Event');
            //this.IsTriggerTypeSelected('Event');
            //this.getTriggerTypeListByTriggerType(taskData.taskData[0].TriggerType)
          }
          else if (taskData.taskData[0].TriggerType === 2) {
            this.activatedTaskForm.controls.TriggerType.setValue('Periodic');
            this.CheckTriggerType('Periodic');
            //this.IsTriggerTypeSelected('Periodic');
            //this.getTriggerTypeListByTriggerType(taskData.taskData[0].TriggerType)
          }
          else {
            this.activatedTaskForm.controls.TriggerType.setValue('');
          }

          // this.activatedTaskForm.controls.ReminderDays.setValue((taskData.taskData[0].ReminderDays == null || taskData.taskData[0].ReminderDays == undefined) ? 0 : taskData.taskData[0].ReminderDays);
          this.activatedTaskForm.controls.ReminderDays.setValue((taskData.taskData[0].ReminderDays == null || taskData.taskData[0].ReminderDays == undefined) ? null : taskData.taskData[0].ReminderDays);
          this.activatedTaskForm.controls.Department.setValue((taskData.taskData[0].DepartmentGroupID == null || taskData.taskData[0].DepartmentGroupID == undefined) ? '0' : taskData.taskData[0].DepartmentGroupID);
          this.activatedTaskForm.controls.EscalationDays.setValue((taskData.taskData[0].EscalationDays == null || taskData.taskData[0].EscalationDays == undefined) ? null : taskData.taskData[0].EscalationDays);
          this.activatedTaskForm.controls.Level2EscalationDays.setValue(taskData.taskData[0].Level2EscalationDays);
          this.activatedTaskForm.controls.Escalation2ofResponsibleUser.setValue((taskData.taskData[0].Escalation2ofResponsibleUser == null || taskData.taskData[0].Escalation2ofResponsibleUser == undefined) ? '' : taskData.taskData[0].Escalation2ofResponsibleUser);
          this.activatedTaskForm.controls.Escalation1ofResponsibleUser.setValue((taskData.taskData[0].Escalation1ofResponsibleUser == null || taskData.taskData[0].Escalation1ofResponsibleUser == undefined) ? '' : taskData.taskData[0].Escalation1ofResponsibleUser);
          this.activatedTaskForm.controls.Escalation2ofAssignedTo.setValue((taskData.taskData[0].Escalation2ofAssignedTo == null || taskData.taskData[0].Escalation2ofAssignedTo == undefined) ? '' : taskData.taskData[0].Escalation2ofAssignedTo);
          this.activatedTaskForm.controls.Escalation1ofAssignedTo.setValue((taskData.taskData[0].Escalation1ofAssignedTo == null || taskData.taskData[0].Escalation1ofAssignedTo == undefined) ? '' : taskData.taskData[0].Escalation1ofAssignedTo);
          this.activatedTaskForm.controls.Collegues.setValue((taskData.taskData[0].Collegues == null || taskData.taskData[0].Collegues == undefined) ? '' : taskData.taskData[0].Collegues);
          this.activatedTaskForm.controls.AssignedTo.setValue((taskData.taskData[0].AssignedTo == null || taskData.taskData[0].AssignedTo == undefined) ? '' : taskData.taskData[0].AssignedTo);
          const reminderDaysTemp = this.activatedTaskForm.controls['ReminderDays'].value;
          const baseDateForReminder = this.parseApiDate(taskData.taskData[0].FixedDate) || this.parseApiDate(taskData.taskData[0].TriggerStartDate);
          if (baseDateForReminder !== null && reminderDaysTemp !== null && reminderDaysTemp !== undefined && reminderDaysTemp !== '') {
            const reminderDate = this.addDays(baseDateForReminder, Number(reminderDaysTemp));
            this.activatedTaskForm.controls.ReminderDate.setValue(this.convertDateToPicker(reminderDate), { emitEvent: false });
          } else {
            this.activatedTaskForm.controls.ReminderDate.setValue(null, { emitEvent: false });
          }

          // Get CompletionDays directly from API response, not from form control
          const taskDataItem = taskData.taskData[0];
          const completionDaysFromApi = taskDataItem.CompletionDays;
          const dueDateFromApi = this.parseApiDate(taskDataItem.DueDate);

          // Determine base date for calculating due date from CompletionDays
          // Priority: FixedDate > TriggerStartDate > TaskNextActivateDate (for activated tasks) > CreatedDate/createdDate > ReminderStartDate (calculated)
          let baseDateForCompletion = this.parseApiDate(taskDataItem.FixedDate) || 
                                      this.parseApiDate(taskDataItem.TriggerStartDate) ||
                                      this.parseApiDate(taskDataItem.TaskNextActivateDate) ||
                                      this.parseApiDate(taskDataItem.CreatedDate) ||
                                      this.parseApiDate(taskDataItem.createdDate);
          
          // If no base date found, try ReminderStartDate (calculated from ReminderDays)
          if (!baseDateForCompletion && baseDateForReminder) {
            baseDateForCompletion = baseDateForReminder;
          }
          
          // Also check if ReminderStartDate is directly available in the response
          if (!baseDateForCompletion) {
            const reminderStartDateFromApi = this.parseApiDate(taskDataItem.ReminderStartDate) || 
                                            this.parseApiDate(taskDataItem.reminderStartDate);
            if (reminderStartDateFromApi) {
              baseDateForCompletion = reminderStartDateFromApi;
            }
          }

          let completionDateToSet: Date | null = null;
          
          // Priority 1: Use DueDate directly if available
          if (dueDateFromApi) {
            completionDateToSet = dueDateFromApi;
          }
          // Priority 2: Calculate from base date + CompletionDays if both are available
          // Check if CompletionDays is a valid number (including 0)
          else if (baseDateForCompletion && completionDaysFromApi !== null && completionDaysFromApi !== undefined && completionDaysFromApi !== '' && !isNaN(Number(completionDaysFromApi))) {
            completionDateToSet = this.addDays(baseDateForCompletion, Number(completionDaysFromApi));
          }

          if (completionDateToSet) {
            const pickerValue = this.convertDateToPicker(completionDateToSet);
            this.activatedTaskForm.controls.CompletionDate.setValue(pickerValue, { emitEvent: false });
            this.CompletionDateModel = pickerValue;
          } else {
            this.activatedTaskForm.controls.CompletionDate.setValue(null, { emitEvent: false });
            this.CompletionDateModel = null;
          }

          this.updateReminderDays();

          this.updateReminderDays();

          this.onSelectMemberDisableFromOther();
          if (taskData.taskData[0].TaskRemarks != null && taskData.taskData[0].TaskRemarks != undefined) {
            this.activatedTaskForm.controls.TaskRemarks.setValue((taskData.taskData[0].TaskRemarks == null || taskData.taskData[0].TaskRemarks == undefined) ? "" : taskData.taskData[0].TaskRemarks);
          }
          if (taskData.taskData[0].TaskStatus != null && taskData.taskData[0].TaskStatus != undefined) {
            //this.activatedTaskForm.controls.TaskStatus.setValue((taskData.taskData[0].TaskStatus == null || taskData.taskData[0].TaskStatus == undefined) ? '' : taskData.taskData[0].TaskStatus);
            var taskStatus = this.getTaskStatus(taskData.taskData[0].DueDate, taskData.taskData[0].CompletedDate, taskData.taskData[0].TaskStatus);
            this.activatedTaskForm.controls.TaskStatus.setValue(taskStatus);

          }
          else {
            this.activatedTaskForm.controls.TaskStatus.setValue('1');
          }

          if (taskData.taskData[0].ActivatedTaskParticularId != null || taskData.taskData[0].ActivatedTaskParticularId != undefined) {
            this.activatedTaskForm.controls.TaskParticulars.setValue(taskData.taskData[0].ActivatedTaskParticularId.TaskParticulars);
          } else {
            this.activatedTaskForm.controls.TaskParticulars.setValue("");
          }
        }
        this.activatedTaskForm.get('CompletionDate').valueChanges
          .subscribe((date1: any) => {
            const completionDate = this.toDate(date1);
            const baseDate = this.toDate(this.getReminderBaseDateValue());

            if (!completionDate || !baseDate) {
              this.activatedTaskForm.controls.CompletionDays.setValue(null, { emitEvent: false });
              return;
            }

            let differenceDate = this.calculateDaysBetween(baseDate, completionDate)
            this.activatedTaskForm.controls.CompletionDays.setValue(differenceDate, { emitEvent: false });
          });
        this.isPageLoading = false;
      }, () => {
        this.isPageLoading = false;
      });
  }


  dateOfEndDateChangeEvent() {
    // this.MinDocumentDateDate = this.TriggerStartingDateModel;
    if (this.EndDateModel != null) {
      const triggerDateValue = this.toDate(this.TriggerStartingDateModel);
      const endDateValue = this.toDate(this.EndDateModel);
      if (triggerDateValue && endDateValue) {
        var diffIncorporationDateFromFinancialYearDate = (moment(triggerDateValue).diff(moment(endDateValue), "days"));
        if (diffIncorporationDateFromFinancialYearDate > 0) {
          this.IsTriggerDateGreaterEndDate = true;
        }
        else {
          this.IsTriggerDateGreaterEndDate = false;
        }
      } else {
        this.IsTriggerDateGreaterEndDate = false;
      }
    }
  }

  getUsersList() {
    this.users = [];
    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          this.users = result.result;
          this.users = this.commonFunction.sortByKey(this.users, 'FirstName');
          for (let i in this.users) {
            this.users[i].isDisable = false;
          }
        }
      })
  }

  getescalation2ResponsibleUsersList() {
    this.escalation2ofResponsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 2 of Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.escalation2ofResponsibleUsers =
            this.escalation2ofResponsibleUsers.map(function (element) {
              return {
                label: element.FirstName + " " + element.LastName,
                value: element._id,
                disabled: element.isDisable,
              };
            });
        }
      });

  }

  getescalation1ResponsibleUsersList() {
    this.escalation1ofResponsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {

            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 1 of Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');

          } else {
            this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.escalation1ofResponsibleUsers =
            this.escalation1ofResponsibleUsers.map(function (element) {
              return {
                label: element.FirstName + " " + element.LastName,
                value: element._id,
                disabled: element.isDisable,
              };
            });
        }
      })
  }


  deleteProof(id) {

    var uploadedProof = {
      activatedTaskId: this.taskId,
      documentId: null
    }
    this.taskService.updateDocumentIdforActivatedTask(uploadedProof)
      .subscribe(updatedActivatedTask => {
        if (updatedActivatedTask.status == 0) {

          this.documentManagementMasterService.deleteDocumentManagement(id).subscribe((data: any) => {
            if (data.status == 0) {

              this.alert.success("Proof deleted successfully.");
              $('#confirmation').modal('toggle');
              this.ngOnInit();
            }
            else {
              $('#confirmation').modal('toggle');
              this.alert.error(data.message);
            }
          });

        }
        else {
          this.alert.error(updatedActivatedTask.message);
        }
      });
  }

  getescalation1UsersList() {
    this.escalation1Users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 1"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation1Users = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.escalation1Users = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.escalation1Users = this.escalation1Users.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
          this.tempEscalation1Users = this.escalation1Users;
          this.onSelectMemberDisableFromOther();
        }
      })

  }

  getescalation2UsersList() {
    this.escalation2Users = [];

    this.taskService.getUsersList()
      .subscribe((result: any) => {
        if (result.status == 0) {

          if (environment.PSS == true) {

            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 2"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation2Users = this.commonFunction.sortByKey(userlist, 'FirstName');
          }
          else {
            this.escalation2Users = this.commonFunction.sortByKey(result.result, 'FirstName');
          }

          this.escalation2Users = this.escalation2Users.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
          this.tempEscalation2Users = this.escalation2Users;

          this.onSelectMemberDisableFromOther();
        }
      })

  }
  /*getescalation1UsersList() {
    this.escalation1Users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 1"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation1Users = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.escalation1Users = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
        for (let i in this.escalation1Users) {
          this.escalation1Users[i].isDisable = false;
        }
        this.onSelectMemberDisableFromOther();
      })

  }

  getescalation2UsersList() {
    this.escalation2Users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {

            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 2"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation2Users = this.commonFunction.sortByKey(userlist, 'FirstName');
          }
          else {
            this.escalation2Users = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
        for (let i in this.escalation2Users) {
          this.escalation2Users[i].isDisable = false;
        }
        this.onSelectMemberDisableFromOther();
      })

  }*/

  getassignedUsersList() {
    this.assignedusers = [];
    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          this.assignedusers = this.commonFunction.sortByKey(result.result, 'FirstName');
          this.assignedusers = this.assignedusers.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
          this.tempAssignedusers = this.assignedusers;
          this.onSelectMemberDisableFromOther();
          // for (let i in this.assignedusers) {
          //   this.assignedusers[i].isDisable = false;
          // }
          // this.onSelectMemberDisableFromOther();
        }
      })
  }



  getresponsibleUsersList() {
    this.responsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.responsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.responsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.responsibleUsers = this.responsibleUsers.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
        }
      })
  }

  getColleguesList() {
    this.collegues = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        this.collegues = this.commonFunction.sortByKey(
          result.result,
          "FirstName"
        );
        for (let i in this.collegues) {
          this.collegues[i].isDisable = false;
        }
        this.collegues = this.collegues.map(function (element) {
          return {
            label: element.FirstName + " " + element.LastName,
            value: element._id,
            disabled: element.isDisable,
          };
        });
        this.tempCollegues = this.collegues;
        this.onSelectMemberDisableFromOther();
      }
    });
  }

  onlyNumber(event) {
    var keyCode = window.event ? event.keyCode : event.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode == 109) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(event.key) == -1) {
        event.preventDefault();
      }
      //restrict up to 2 digits
      if ((event.target.value + event.key).length > 5) {
        event.preventDefault();
      }

    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !event.ctrlKey) {
        event.preventDefault();
      }
    }
  }



  getTriggerTypeListByTriggerType(triggerType) {
    this.taskTriggerTypes = [];
    this.taskService.getTriggerTypeListByTriggerType(triggerType)
      .subscribe(tasktriggerList => {
        if (tasktriggerList.status == 0) {
          this.taskTriggerTypes = tasktriggerList.tasktriggerList;
        }
      })

    this.showSelectedTriggerID(triggerType, this.triggerID);
  }



  CheckTriggerType(item: any) {
    this.triggerType = item;
    // this.triggerType =  this.activatedTaskForm.controls.tasktriggerId.value;
    this.getTriggerTypeListByTriggerType(this.triggerType);
    if (item === "Periodic") {
      this.activatedTaskForm.controls.TriggerStartingDate.setValidators([Validators.required]);
      this.activatedTaskForm.controls.TriggerStartingDate.updateValueAndValidity();

    } else {

      this.activatedTaskForm.controls.TriggerStartingDate.clearValidators();
      this.activatedTaskForm.controls.TriggerStartingDate.updateValueAndValidity();
      this.activatedTaskForm.controls.TriggerStartingDate.setValue('');

    }

    this.showSelectedTriggerID(this.triggerType, this.triggerID);

  }

  IsTriggerTypeSelected(name: any): boolean {
    if (!this.triggerType) { // if no radio button is selected, always return false so every nothing is shown  
      return false;
    }
    return (this.triggerType === name); // if current radio button is selected, return true, else return false  
  }

  initialiseJqueryEvents() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  getTodaysDate() {
    var newDate = new Date();
    this.todaysDate = { year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate() };
  }

  checkRemindersValidation() {

    var reminderStartDays = (this.activatedTaskForm.controls.ReminderDays.value != null || this.activatedTaskForm.controls.ReminderDays.value != undefined) ? this.activatedTaskForm.controls.ReminderDays.value : 0;
    var reminderFrequency = (this.activatedTaskForm.controls.ReminderFrequency.value != null || this.activatedTaskForm.controls.ReminderFrequency.value != undefined) ? this.activatedTaskForm.controls.ReminderFrequency.value : 0;
    var firstEscalationStart = (this.activatedTaskForm.controls.EscalationDays.value != null || this.activatedTaskForm.controls.EscalationDays.value != undefined) ? this.activatedTaskForm.controls.EscalationDays.value : 0;
    var secondEscalationStart = (this.activatedTaskForm.controls.Level2EscalationDays.value != null || this.activatedTaskForm.controls.Level2EscalationDays.value != undefined) ? this.activatedTaskForm.controls.Level2EscalationDays.value : 0;
    var firstEscalationreminderfrequency = (this.activatedTaskForm.controls.ReminderFrequencyLevel1.value != null || this.activatedTaskForm.controls.ReminderFrequencyLevel1.value != undefined) ? this.activatedTaskForm.controls.ReminderFrequencyLevel1.value : 0;
    var secondEscalationreminderfrequency = (this.activatedTaskForm.controls.ReminderFrequencyLevel2.value != null || this.activatedTaskForm.controls.ReminderFrequencyLevel2.value != undefined) ? this.activatedTaskForm.controls.ReminderFrequencyLevel2.value : 0;

    //Created by Roshan --messages not cleared if date is valid 
    if (reminderStartDays != "" || reminderStartDays !== null) {
      if (parseInt(reminderStartDays) < parseInt(reminderFrequency)) {
        this.checkValidationInput = true;
        this.reminderFrequencyError = {
          isError: true, errorMessage: 'Reminder frequency cannot be more than reminder start date.'
        };
        return false;
      }
      else if (parseInt(reminderStartDays) < parseInt(firstEscalationStart)) {
        this.checkValidationInput = true;
        this.firstEscalationStartError = {
          isError: true, errorMessage: '1st Escalation start cannot be more than Reminder start date.'
        };
        return false;
      }
      else if (parseInt(firstEscalationStart) < parseInt(secondEscalationStart)) {
        this.checkValidationInput = true;
        this.secondEscalationStartError = {
          isError: true, errorMessage: '2nd Escalation start cannot be more than 1st Escalation start.'
        };
        return false;
      }
      else if (parseInt(firstEscalationStart) < parseInt(firstEscalationreminderfrequency)) {
        this.checkValidationInput = true;
        this.firstEscalationreminderFrequencyError = {
          isError: true, errorMessage: '1st Escalation reminder frequency cannot be more than 1st Escalation start date.'
        };
        return false;
      }
      else if (parseInt(secondEscalationStart) < parseInt(secondEscalationreminderfrequency)) {
        this.checkValidationInput = true;
        this.secondEscalationreminderFrequencyError = {
          isError: true, errorMessage: '2nd Escalation reminder frequency cannot be more than 2nd Escalation start date.'
        };
        return false;
      }

      else {
        this.checkValidationInput = false;
        this.reminderFrequencyError = {
          isError: false, errorMessage: ''
        };
        this.firstEscalationStartError = {
          isError: false, errorMessage: ''
        };
        this.secondEscalationStartError = {
          isError: false, errorMessage: ''
        };
        this.firstEscalationreminderFrequencyError = {
          isError: false, errorMessage: ''
        };
        this.secondEscalationreminderFrequencyError = {
          isError: false, errorMessage: ''
        };

      }
    }
    else
      this.error = { isError: false, errorMessage: '' }






    return true;
  }

  getMinimumDate(triggerDate) {
    //var newDate = new Date();
    this.minimumDate = {
      year: triggerDate.getUTCFullYear(),
      month: triggerDate.getUTCMonth() + 1,
      day: triggerDate.getUTCDate()
    };
  }


  ngOnInit() {
    
    this.environmentSettings = environment;

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.initialiseJqueryEvents();

    this.getescalation2ResponsibleUsersList();
    this.getescalation1ResponsibleUsersList();
    this.getescalation2UsersList();
    this.getescalation1UsersList();
    this.getassignedUsersList();
    this.getresponsibleUsersList();

    this.IsSelectedUpload = false;
    this.getMeetingTypeList();
    this.getGroupmasterList();
    this.getTaskTriggerTypeList();
    this.getUsersList();
    this.getColleguesList();
    this.downloadLink = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/'
    this.activatedRoute.params.subscribe(params => {
      if (params['taskId'] != undefined) {
        this.taskId = params['taskId'];
        var data = {
          module: 'ActivatedTask',
          ID: params['taskId'],
          CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        this.isPageLoading = true;
        this.meetingService.authonticateDataForComapnay(data).subscribe(meetingAccess => {
          if (meetingAccess.status == 0) {
            this.GetSelectedTaskDetail(this.taskId);
          } else {
            this.isPageLoading = false;
            this.authAlert.validateModuleWithPermissions('ActivatedTask', params['taskId'], meetingAccess.companyID, 'edit');
          }
        }, () => {
          this.isPageLoading = false;
        });

      }
    });

    $("btnsaveTask").prop("disabled", false); // Enable update button
    this.activatedTaskForm = new FormGroup({
      ReminderDate: new FormControl(),
      TaskName: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      TaskDescription: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      TriggerType: new FormControl('', [Validators.required]),
      groupId: new FormControl('', [Validators.required]),
      //meetingtypeId: new FormControl('', [Validators.required]),
      meetingtypeId: new FormControl('', []),
      tasktriggerId: new FormControl('', [Validators.required]),
      ReminderDays: new FormControl(null),
      ReminderFrequency: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      EscalationDays: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      Level2EscalationDays: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      ReminderFrequencyLevel1: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      ReminderFrequencyLevel2: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      // CompletionDays: new FormControl(0, [Validators.pattern('^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$')]),
      CompletionDays: new FormControl(0, [Validators.pattern('^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$'), Validators.maxLength(5), Validators.max(9999), Validators.min(-9999)]),
      CompletionDate: new FormControl(),
      EmailContents: new FormControl('', []),
      Department: new FormControl('', []),
      policytypeId: new FormControl('', []),
      risktypeId: new FormControl('', []),
      Email: new FormControl('', [Validators.required]),
      DateOption: new FormControl('', [Validators.required]),
      PreConsequences: new FormControl('', []),
      UserConsequences: new FormControl('', []),
      AssignedTo: new FormControl('', []),
      ResponsibleUser: new FormControl('', []),
      Escalation1ofAssignedTo: new FormControl('', []),
      Escalation2ofAssignedTo: new FormControl('', []),
      Escalation1ofResponsibleUser: new FormControl('', []),
      Escalation2ofResponsibleUser: new FormControl('', []),
      TriggerStartingDate: new FormControl('', []),
      endDate: new FormControl('', []),
      CompletedDate: new FormControl('', []),
      Collegues: new FormControl('', []),
      TaskRemarks: new FormControl('', []),
      TaskStatus: new FormControl('', []),
      TaskParticulars: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      fixedDate: new FormControl('', []),
      DocumentFile: new FormControl('', [])
    });

    this.activatedTaskForm.get('ReminderDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.activatedTaskForm.get('TriggerStartingDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.activatedTaskForm.get('fixedDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.activatedTaskForm.get('DateOption').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.updateReminderDays();

    this.activatedTaskForm.controls['Escalation2ofResponsibleUser'].disable();

    this.activatedTaskForm.controls['Escalation1ofResponsibleUser'].disable();

    this.uploadProofactivatedTaskForm = new FormGroup({
      fileData: new FormControl('', [])
    });

    this.getTodaysDate();

    // this.hasPermission = this.commonFunction.validateURL('ActivatedTaskAll', 'edit') || this.commonFunction.validateURL('ActivatedTaskIndividual', 'edit');
    
    var moduleName = '';
    var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskAll"; })
    var libraryTasklistAdmin1 = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskIndividual"; })
    if (libraryTasklistAdmin == true) {
      moduleName = 'ActivatedTaskAll'
    }
    if (libraryTasklistAdmin1 == true) {
      moduleName = 'ActivatedTaskIndividual'
    }

    this.hasPermission = this.commonFunction.validateURL(moduleName, 'edit');
    this.disableControls(this.hasPermission);
  }
  getDateDifference(date1: any,
    date2: any) {
    const startDate = this.toDate(date1);
    const endDate = this.toDate(date2);

    if (!startDate || !endDate) {
      return null;
    }

    return this.calculateDaysBetween(startDate, endDate);
  }

  private updateReminderDays(): void {
    const reminderControl = this.activatedTaskForm.get('ReminderDate');
    const reminderDaysControl = this.activatedTaskForm.get('ReminderDays');

    if (!reminderControl || !reminderDaysControl) {
      return;
    }

    const reminderDate = this.toDate(reminderControl.value);
    const baseDate = this.toDate(this.getReminderBaseDateValue());

    if (!reminderDate || !baseDate) {
      reminderDaysControl.setValue(null, { emitEvent: false });
      this.clearReminderDateValidationError('reminderBeforeBase');
      return;
    }

    const difference = this.calculateDaysBetween(baseDate, reminderDate);

    if (difference < 0) {
      reminderDaysControl.setValue(null, { emitEvent: false });
      this.setReminderDateValidationError('reminderBeforeBase');
    } else {
      reminderDaysControl.setValue(difference, { emitEvent: false });
      this.clearReminderDateValidationError('reminderBeforeBase');
    }
  }

  private getReminderBaseDateValue(): any {
    const fixedDate = this.activatedTaskForm.get('fixedDate')?.value;
    if (this.hasDateValue(fixedDate)) {
      return fixedDate;
    }
    return this.activatedTaskForm.get('TriggerStartingDate')?.value;
  }

  private hasDateValue(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized !== '' && normalized !== 'null' && normalized !== 'invalid date';
    }

    return true;
  }

  private parseApiDate(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'object' && value.year !== undefined && value.month !== undefined && value.day !== undefined) {
      return new Date(Date.UTC(Number(value.year), Number(value.month) - 1, Number(value.day)));
    }

    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  private convertDateToPicker(date: Date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  }

  private addDays(date: Date, days: number): Date {
    const result = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  private toDate(value: any): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()));
    }

    if (typeof value === 'object' && value.year !== undefined && value.month !== undefined && value.day !== undefined) {
      const year = Number(value.year);
      const month = Number(value.month);
      const day = Number(value.day);
      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return null;
      }
      return new Date(Date.UTC(year, month - 1, day));
    }

    if (typeof value === 'number') {
      const parsedFromNumber = new Date(value);
      return isNaN(parsedFromNumber.getTime()) ? null : parsedFromNumber;
    }

    if (typeof value === 'string') {
      const parsedFromString = new Date(value);
      return isNaN(parsedFromString.getTime()) ? null : parsedFromString;
    }

    return null;
  }

  private calculateDaysBetween(start: Date, end: Date): number {
    const startUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    const endUTC = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    return Math.round((endUTC - startUTC) / (1000 * 60 * 60 * 24));
  }

  private setReminderDateValidationError(errorKey: string): void {
    const control = this.activatedTaskForm.get('ReminderDate');
    if (!control) {
      return;
    }

    const errors = { ...(control.errors || {}) };
    if (!errors[errorKey]) {
      errors[errorKey] = true;
      control.setErrors(errors);
    }
  }

  private clearReminderDateValidationError(errorKey?: string): void {
    const control = this.activatedTaskForm.get('ReminderDate');
    if (!control || !control.errors) {
      return;
    }

    const errors = { ...control.errors };
    if (errorKey) {
      delete errors[errorKey];
    } else {
      Object.keys(errors).forEach(key => delete errors[key]);
    }

    if (Object.keys(errors).length === 0) {
      control.setErrors(null);
    } else {
      control.setErrors(errors);
    }
  }

  onSelectMemberDisableFromOther(status = false) {
    const form = this.activatedTaskForm.controls;

    const colleguesToId = form["Collegues"].value || [];
    const assignedToId = form["AssignedTo"].value || [];
    const escalation1ofAssignedTo = form["Escalation1ofAssignedTo"].value || [];
    const escalation2ofAssignedTo = form["Escalation2ofAssignedTo"].value || [];

    // Filter assigned users
    if (Array.isArray(this.tempAssignedusers)) {
      this.assignedusers = this.tempAssignedusers.filter(
        (el) =>
          !colleguesToId.includes(el.value) &&
          !escalation1ofAssignedTo.includes(el.value) &&
          !escalation2ofAssignedTo.includes(el.value)
      );
    }

    let colleag: any[] = [];
    let escalation1Users: any[] = [];
    let escalation2Users: any[] = [];
    const selectedList: string[] = [];
    this.selectedUsers = [
      ...colleguesToId,
      ...assignedToId,
      ...escalation1ofAssignedTo,
      ...escalation2ofAssignedTo,
    ];

    const tempIds: string[] = [];
    const tempIds1: string[] = [];
    const tempIds2: string[] = [];

    this.userTeamData.forEach((ele) => {
      if (!assignedToId.includes(ele.userId)) return;

      if (!selectedList.includes(ele.userId)) {
        selectedList.push(ele.userId);
      }

      // Colleague loop
      ele.colleague?.forEach((ele1) => {
        if (
          ele1.userId &&
          !assignedToId.includes(ele1.userId) &&
          !tempIds.includes(ele1.userId) &&
          !escalation1ofAssignedTo.includes(ele1.userId) &&
          !escalation2ofAssignedTo.includes(ele1.value)
        ) {
          tempIds.push(ele1.userId);
          colleag.push({ label: ele1.userName, value: ele1.userId });
        }

        if (
          this.selectedUsers.includes(ele1.userId) &&
          !selectedList.includes(ele1.userId)
        ) {
          selectedList.push(ele1.userId);
        }
      });

      // Escalation 2 loop
      ele.escalation2?.forEach((ele1) => {
        if (
          ele1.userId &&
          !assignedToId.includes(ele1.userId) &&
          !tempIds1.includes(ele1.userId) &&
          !colleguesToId.includes(ele1.userId) &&
          !escalation1ofAssignedTo.includes(ele1.value)
        ) {
          tempIds1.push(ele1.userId);
          escalation2Users.push({ label: ele1.userName, value: ele1.userId });
        }

        if (
          this.selectedUsers.includes(ele1.userId) &&
          !selectedList.includes(ele1.userId)
        ) {
          selectedList.push(ele1.userId);
        }
      });

      // Escalation 1 loop
      ele.escalation1?.forEach((ele1) => {
        if (
          ele1.userId &&
          !assignedToId.includes(ele1.userId) &&
          !tempIds2.includes(ele1.userId) &&
          !colleguesToId.includes(ele1.userId) &&
          !escalation2ofAssignedTo.includes(ele1.value)
        ) {
          tempIds2.push(ele1.userId);
          escalation1Users.push({ label: ele1.userName, value: ele1.userId });
        }

        if (
          this.selectedUsers.includes(ele1.userId) &&
          !selectedList.includes(ele1.userId)
        ) {
          selectedList.push(ele1.userId);
        }
      });
    });

    // Prepare data lists (safe order)
    let colleagData = colleag.map((ele) => ele.value);
    let escalationData = escalation1Users.map((ele) => ele.value);
    let escaltion2Data = escalation2Users.map((ele) => ele.value);

    // Apply _.without in proper order
    colleagData = _.without(colleagData, ...escalationData, ...escaltion2Data);
    escalationData = _.without(escalationData, ...colleagData, ...escaltion2Data);
    escaltion2Data = _.without(escaltion2Data, ...colleagData, ...escalationData);

    // Filter dropdown data
    if (Array.isArray(this.tempCollegues)) {
      this.collegues = this.tempCollegues.filter(
        (el) =>
          (!assignedToId.includes(el.value) &&
            !escalation1ofAssignedTo.includes(el.value) &&
            !escalation2ofAssignedTo.includes(el.value)) ||
          colleguesToId.includes(el.value)
      );
    }

    if (Array.isArray(this.tempEscalation1Users)) {
      this.escalation1Users = this.tempEscalation1Users.filter(
        (el) =>
          (!assignedToId.includes(el.value) &&
            !colleguesToId.includes(el.value) &&
            !escalation2ofAssignedTo.includes(el.value)) ||
          escalation1ofAssignedTo.includes(el.value)
      );
    }

    if (Array.isArray(this.tempEscalation2Users)) {
      this.escalation2Users = this.tempEscalation2Users.filter(
        (el) =>
          (!assignedToId.includes(el.value) &&
            !colleguesToId.includes(el.value) &&
            !escalation1ofAssignedTo.includes(el.value)) ||
          escalation2ofAssignedTo.includes(el.value)
      );
    }

    // Patch form if status = true
    if (status) {
      form["Collegues"].setValue(colleagData);
      form["Escalation1ofAssignedTo"].setValue(escalationData);
      form["Escalation2ofAssignedTo"].setValue(escaltion2Data);
    }
  }


  onChange(value) {
    if (value) {
      this.activatedTaskForm.controls['Escalation1ofResponsibleUser'].enable();
      this.activatedTaskForm.controls['Escalation2ofResponsibleUser'].enable();


    }
    else {
      this.activatedTaskForm.controls['Escalation1ofResponsibleUser'].disable();
      this.activatedTaskForm.controls['Escalation2ofResponsibleUser'].disable();
      this.activatedTaskForm.controls['Escalation1ofResponsibleUser'].setValue('');
      this.activatedTaskForm.controls['Escalation2ofResponsibleUser'].setValue('');

    }

  }


  disableControls(editPermission: boolean) {
    if (!editPermission) {
      this.activatedTaskForm.controls.TaskName.disable();
      this.activatedTaskForm.controls.TaskDescription.disable();
      this.activatedTaskForm.controls.TriggerType.disable();
      this.activatedTaskForm.controls.groupId.disable();
      this.activatedTaskForm.controls.meetingtypeId.disable();
      this.activatedTaskForm.controls.tasktriggerId.disable();
      this.activatedTaskForm.controls.ReminderDays.disable();
      this.activatedTaskForm.controls.ReminderFrequency.disable();
      this.activatedTaskForm.controls.EscalationDays.disable();
      this.activatedTaskForm.controls.Level2EscalationDays.disable();
      this.activatedTaskForm.controls.ReminderFrequencyLevel1.disable();
      this.activatedTaskForm.controls.ReminderFrequencyLevel2.disable();
      this.activatedTaskForm.controls.CompletionDays.disable();
      this.activatedTaskForm.controls.EmailContents.disable();
      this.activatedTaskForm.controls.Department.disable();
      this.activatedTaskForm.controls.policytypeId.disable();
      this.activatedTaskForm.controls.risktypeId.disable();
      this.activatedTaskForm.controls.Department.disable();
      this.activatedTaskForm.controls.PreConsequences.disable();
      this.activatedTaskForm.controls.UserConsequences.disable();
      this.activatedTaskForm.controls.AssignedTo.disable();
      this.activatedTaskForm.controls.ResponsibleUser.disable();
      this.activatedTaskForm.controls.AssignedTo.disable();
      this.activatedTaskForm.controls.Escalation1ofAssignedTo.disable();
      this.activatedTaskForm.controls.Escalation2ofAssignedTo.disable();
      this.activatedTaskForm.controls.Escalation1ofResponsibleUser.disable();
      this.activatedTaskForm.controls.Escalation1ofResponsibleUser.disable();
      this.activatedTaskForm.controls.TriggerStartingDate.disable();
      this.activatedTaskForm.controls.CompletedDate.disable();
      this.activatedTaskForm.controls.Collegues.disable();
      this.activatedTaskForm.controls.TaskRemarks.disable();
      this.activatedTaskForm.controls.TaskStatus.disable();
      this.activatedTaskForm.controls.DateOption.disable();
      this.activatedTaskForm.controls.Escalation2ofResponsibleUser.disable();
      this.activatedTaskForm.controls.TaskParticulars.disable();
    }
  }
  checkTriggerId(triggerId): boolean {
    if (triggerId == "5eb94ca3ffaa93751ec4f387") {
      return true;
    } else {
      return false;
    }
  }

  initiateUploadProof() {
    this.getTaskProofFiles();
    $("#uploadProofDialogTitle").html("Task Proof");
    $("#uploadProofDialog1").modal('toggle');
  }

  proofChangeEvent(fileInput: any) {
    this.typeHasError = false
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
      this.typeHasError = false;
    } else {
      this.typeHasError = true;
    }
  }

  uploadProofFile() {
    var file = this.filesToUpload;
    var self = this;
    var pdfData = [];
    this.insertFileIndividuallyInDocumentForPdf('Task Proof', file, 'Attachment').then(function (response) {

      if (response.status == 0) {
        for (var i = 0; i < response.result.length; i++) {
          var data = {
            IsAvailable: true,
            TaskId: self.taskId,
            DocumentManagementID: response.result[i].Document._id,
            UploadDate: new Date(),
            IsPublished: true,
            DocName: response.result[i].Document.OriginalFileName,
            UploadFileName: response.result[i].Document.Filename,
          }
          pdfData.push(data);
        }
        self.taskService.uploadTaskProof(pdfData).subscribe(responseData => {
          self.alert.success("Proof File Uploaded Successfully");
          self.getTaskProofFiles()
          self.filesToUpload = undefined;
          $(".fileUpload").val("");
        })
      } else {
        self.alert.error(response.message);
      }
    }, (error) => {
      this.alert.error(error);
    })
  }

  insertFileIndividuallyInDocumentForPdf(fileFor, file, type): Promise<any> {
    return this.makeFileRequest2(environment.pssServerUrl + "documentManagement/taskProofFileUpload/", [], file, fileFor, type).then((result) => {
      if (result) {
        return this.documentManagementMasterService.addMultiplePdfDocuments(result)
          .toPromise().then(res => { return Promise.resolve(res); })
        // documentManagement/--Post
      }
    })
  }

  makeFileRequest2(url: string, params: Array<string>, files: Array<File>, fileFor, type) {
    var pdfArray = [];
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = name;

        var documentManagement = {
          "DocumentManagement": {
            DocumentName: this.titleOnAddUpdate + '- Documents-' + Date.now() + fileFor + ' ' + type + ' - ' + this.FileOrignalName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }

        pdfArray.push(documentManagement);
        this.pdfArray1.push(documentManagement);
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(pdfArray);
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  getTaskProofFiles() {
    this.taskService.getTaskProofFiles(this.taskId)
      .subscribe(taskProofResponse => {
        if (taskProofResponse.status == 0) {
          $("#groupTable").DataTable().destroy();
          this.taskProofData = []
          this.taskProofData = taskProofResponse.data.TaskProof;
          this.dtTrigger.next();
          setTimeout(() => {
            $("#groupTable").DataTable().columns.adjust().draw();
          }, 200);
        }
      })
  }
  downloadDocTask(){
    var token = localStorage.getItem('token')

    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);

    // this.agendaService.downloadDOCS(lastSegOfURL).subscribe(data => {
    //   // var blob = new Blob([data]);
    // var url = window.URL.createObjectURL(blob);
    // console.log(data.url),
    if (lastSegOfURL.endsWith(')')) {
      lastSegOfURL = lastSegOfURL.slice(0, -1); // removes the last character
    }
    window.open(this.downloadURLForUPSI + lastSegOfURL + "/" + token);
  }
  downloadDoc(downloadDocumentID) {
    this.taskService.downloadTaskProof(downloadDocumentID)
  }

  deleteProofDoc(pdfId, documentId) {
    $("#deletePdfConfirmation").modal('toggle');
    this.pdfToDelete = pdfId;
    this.documentIdToDelete = documentId
  }

  removeDoc() {
    this.taskService.removeTaskProof(this.taskId, this.documentIdToDelete, this.pdfToDelete).subscribe(responseData => {
      if (responseData) {
        this.getTaskProofFiles();
      }
    });
  }

  selectUserTeam(assignedUserId) {
    this.taskService.getUserDetailsByAssignedUser(assignedUserId.value).subscribe(response => {
      if (response.data.length > 0) {
        this.activatedTaskForm.controls.Escalation2ofAssignedTo.setValue(response.data[0].escalation2.userId);
        this.activatedTaskForm.controls.Escalation1ofAssignedTo.setValue(response.data[0].escalation1.userId);
        this.activatedTaskForm.controls.Collegues.setValue(response.data[0].colleague.userId);
      } else {
        this.activatedTaskForm.controls.Escalation2ofAssignedTo.setValue(null);
        this.activatedTaskForm.controls.Escalation1ofAssignedTo.setValue(null);
        this.activatedTaskForm.controls.Collegues.setValue(null);
      }
    })
  }
}